import React from 'react';
import Header from './components/Header';
import About from './components/About';
import Experience from './components/Experience';
import FeaturedProjects from './components/FeaturedProjects';
import Contact from './components/Contact';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <About />
      <Experience />
      <FeaturedProjects />
      <Contact />
    </div>
  );
}

export default App;
